// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c473966f","671":"7c279164","914":"039fc946"}[chunkId] + ".chunk.js";
};